module.exports = __webpack_public_path__ + "img/82.c85a8c65.png";